import { render, staticRenderFns } from "./packagegreetingeditcard.vue?vue&type=template&id=572ed9d8"
import script from "./packagegreetingeditcard.vue?vue&type=script&lang=js"
export * from "./packagegreetingeditcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports